// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","menuHeader":"#f9f9fa","StrollerBoxWidget":"bem_a bhj_tp","StrollerBoxWidget__imageCounselling":"bem_b bhj_ke"};